import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, switchMap, tap } from 'rxjs';
import { SepaMandate } from '../../models/sepa-mandates';

@Injectable({
  providedIn: 'root'
})
export class SepaMandatesService {
  protected baseUrl: string = 'json/sepa/mandates';
  protected sepaMandatesSubject: BehaviorSubject<SepaMandate[]>;

  constructor(protected http: HttpClient) {}

  getAllSepaMandates(nocache?: boolean): Observable<SepaMandate[]> {
    if (!this.sepaMandatesSubject) {
      return this.updateSepaMandatesSubject(nocache).pipe(
        switchMap(() => this.sepaMandatesSubject.asObservable())
      );
    }
    return this.sepaMandatesSubject.asObservable();
  }

  getInternalAllSepaMandates(nocache?: boolean): Observable<SepaMandate[]> {
    const headers = {
      maxAge: nocache ? '-1' : '300'
    };
    return this.http.get<SepaMandate[]>(`${this.baseUrl}`, { headers });
  }

  updateSepaMandatesSubject(nocache?: boolean): Observable<SepaMandate[]> {
    return this.getInternalAllSepaMandates(nocache).pipe(
      tap(mandates => {
        if (!this.sepaMandatesSubject) {
          this.sepaMandatesSubject = new BehaviorSubject<SepaMandate[]>(mandates);
        } else {  
          this.sepaMandatesSubject.next(mandates);
        }
      })
    );
  }

  getSepaMandate(id: string): Observable<SepaMandate> {
    return this.http.get<SepaMandate>(`${this.baseUrl}/${id}`);
  }

  saveSepaMandate(mandate: SepaMandate): any {
    return this.http
      .post<SepaMandate>(`${this.baseUrl}`, mandate)
      .pipe(tap(_ => this.updateSepaMandatesSubject(true).subscribe(_ => {})));
  }

  deleteSepaMandate(id: string): any {
    return this.http
      .delete<SepaMandate>(`${this.baseUrl}/${id}`)
      .pipe(tap(_ => this.updateSepaMandatesSubject(true).subscribe(_ => {})));
  }
}
